import { cx } from './cx';

export interface SpinnerProps {
  /** Announced to screen readers; ignored when `decorative`. */
  label?: string;
  size?: 'sm' | 'md' | 'lg';
  /** Inside a control that already conveys busy state (e.g. a loading Button): hide from AT. */
  decorative?: boolean;
  className?: string;
}

const SIZES = { sm: 'size-4', md: 'size-6', lg: 'size-10' } as const;

/** Loading indicator. A `role="status"` region so the label is announced politely. */
export function Spinner({ label = 'Loading…', size = 'md', decorative, className }: SpinnerProps) {
  const svg = (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      className={cx('animate-spin text-primary', SIZES[size], className)}
    >
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.25" strokeWidth="3" />
      <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
  if (decorative) return svg;
  return (
    <span role="status" className="inline-flex items-center gap-2">
      {svg}
      <span className="sr-only">{label}</span>
    </span>
  );
}
